export function formatNumberWithCommas(number: string | number) {
  const num = Number(number);
  if (Number.isNaN(num) || number === '') {
    return '';
  }
  return num.toLocaleString();
}
